/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        alert: {
            borderRadius: {
                value: "12px",
                type: "dimension",
            },
            paddingTop: {
                value: "8px",
                type: "dimension",
            },
            paddingRight: {
                value: "16px",
                type: "dimension",
            },
            paddingBottom: {
                value: "8px",
                type: "dimension",
            },
            paddingLeft: {
                value: "16px",
                type: "dimension",
            },
            gap: {
                value: "16px",
                type: "dimension",
            },
            minHeight: {
                value: "56px",
                type: "dimension",
            },
            icon: {
                fill: {
                    value: "#282e37",
                    type: "color",
                },
                color: {
                    value: "#282e37",
                    type: "color",
                },
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
            },
            message: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.5rem",
                    type: "dimension",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
            },
            action: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
            },
            success: {
                backgroundColor: {
                    value: "#d2ff9c",
                    type: "color",
                },
            },
            info: {
                backgroundColor: {
                    value: "#d7f6ff",
                    type: "color",
                },
            },
            warning: {
                backgroundColor: {
                    value: "#fff2aa",
                    type: "color",
                },
            },
            error: {
                backgroundColor: {
                    value: "#ffedeb",
                    type: "color",
                },
            },
            processing: {
                backgroundColor: {
                    value: "#dadada",
                    type: "color",
                },
            },
            divided: {
                action: {
                    borderTopColor: {
                        value: "#282e37",
                        type: "color",
                    },
                    borderTopWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderTopStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    paddingTop: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "8px",
                        type: "dimension",
                    },
                },
                message: {
                    paddingTop: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "16px",
                        type: "dimension",
                    },
                },
            },
            fixed: {
                borderRadius: {
                    value: "0px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
